<div class="landing-root">
  <div id="map-container">
    <div id="map-bg"></div>
  </div>

  <div class="map-overlay"></div>

  <div class="map-marker marker-1"></div>
  <div class="map-marker marker-2"></div>
  <div class="map-marker marker-3"></div>
  <div class="map-marker marker-4"></div>
  <div class="map-marker marker-5"></div>
  <div class="map-marker marker-6"></div>
  <div class="map-marker marker-7"></div>
  <div class="map-marker marker-8"></div>

  <div class="wrapper platforms">
    <div class="center">
      <img src="assets/images/plogo.png" alt="Buy Rent Sale Network" height="110" (error)="onLogoError($event)">
      <div id="address">
        <h3>Propify Realty Networks Pvt Ltd</h3>
        <p>H, 2-1-279, Street Number 6, Mamatha Nagar Colony, Nagole, Hyderabad, Telangana 500068</p>
        <div class="contact-links">
          <a href="tel:+919618641100">📞 +91 96186 41100</a>
          <a href="mailto:support@buyrentsale.com">✉️ support&#64;buyrentsale.com</a>
        </div>
      </div>
    </div>

    <div class="product l1" (click)="openProductUrl('https://propifyid.com')">
      <h4>PropifyID</h4>
      <p>Digital property identity verification</p>
      <a href="https://propifyid.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">propifyid.com</a>
    </div>

    <div class="product l2" (click)="openProductUrl('https://propifybuilders.com')">
      <h4>PropifyBuilders</h4>
      <p>Builder &amp; project listing network</p>
      <a href="https://propifybuilders.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">propifybuilders.com</a>
    </div>

    <div class="product l3" (click)="openProductUrl('https://propifyacademy.com')">
      <h4>PropifyAcademy</h4>
      <p>Real estate skill development hub</p>
      <a href="https://propifyacademy.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">propifyacademy.com</a>
    </div>

    <div class="product l4" (click)="openProductUrl('https://chat.buyrentsale.com/')">
      <h4>PropTalk</h4>
      <p>Real estate podcast &amp; discussions</p>
      <a href="https://chat.buyrentsale.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">chat.buyrentsale.com</a>
    </div>

    <div class="product l5" (click)="openProductUrl('https://hyderabadlandinvestments.com')">
      <h4>Hyderabad Land</h4>
      <p>Curated land investment platform</p>
      <a href="https://hyderabadlandinvestments.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">Website link</a>
    </div>

    <div class="product r1" (click)="openProductUrl('https://smartbuyerid.com')">
      <h4>SmartBuyerID</h4>
      <p>Privacy-First Property Buyer Identity System</p>
      <a href="https://smartbuyerid.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">smartbuyerid.com</a>
    </div>

    <div class="product r2" (click)="openProductUrl('https://hygrowth.buyrentsale.com/')">
      <h4>HyGrowth</h4>
      <p>Hyderabad growth insights &amp; trends</p>
      <a href="https://hygrowth.buyrentsale.com/" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">Website link</a>
    </div>

    <div class="product r3" (click)="openProductUrl('https://orrhyderabad.com')">
      <h4>ORR Hyderabad</h4>
      <p>Outer Ring Road property hub</p>
      <a href="https://orrhyderabad.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">orrhyderabad.com</a>
    </div>

    <div class="product r4" (click)="openProductUrl('https://futurecityofficial.com')">
      <h4>Future City</h4>
      <p>Next-gen smart city developments</p>
      <a href="https://futurecityofficial.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">futurecityofficial.com</a>
    </div>

    <div class="product r5" (click)="openProductUrl('https://rrrhyderabad.com')">
      <h4>RRR Hyderabad</h4>
      <p>Regional Ring Road investment zone</p>
      <a href="https://rrrhyderabad.com" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">rrrhyderabad.com</a>
    </div>
  </div>

  <div class="mobile-address-footer">
    <h3>Propify Realty Networks Pvt Ltd</h3>
    <p>#302, P and T Colony, Dilsuknagar, Hyderabad - 500060, Telangana, India</p>
    <div class="contact-links">
      <a href="tel:+919618641100">📞 +91 96186 41100</a>
      <a href="mailto:support@buyrentsale.com">✉️ support&#64;buyrentsale.com</a>
    </div>
  </div>
</div>
